<template>
    <div class="user-add-wrap-out">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="doctorAdd-wrap" v-loading="loading">
            <div class="doctor-title">
                <i class="iconfont icon-tongyongbiaotiicon"></i
                ><span>护士信息</span>
            </div>
            <el-form :model="ruleForm" ref="ruleForm" class="rule-from">
                <div class="doctor-base-info">
                    <div class="info-title">基本信息</div>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label-width="16px">
                                <div class="avart-wrap">
                                    <!-- 遮罩 -->
                                    <div class="cover-custom" v-show="imageUrl">
                                        <div class="cover-wrap">
                                            <i
                                                class="el-icon-zoom-in"
                                                @click="avartIn"
                                            ></i>
                                            <i
                                                class="el-icon-delete"
                                                @click="avartDele"
                                            ></i>
                                        </div>
                                    </div>
                                    <el-upload
                                        class="avatar-uploader"
                                        action=""
                                        :auto-upload="false"
                                        :show-file-list="false"
                                        list-type="picture-card"
                                        :http-request="uploadFile"
                                        :on-change="changeUpload"
                                        accept=".jpg, .png"
                                    >
                                        <img
                                            v-if="imageUrl"
                                            :src="imageUrl"
                                            class="avatar-show"
                                        />
                                        <div else class="avatar-img">
                                            <i class="iconfont icon-camera"></i>
                                            <div class="uploader-title">
                                                上传头像
                                            </div>
                                        </div>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                label="姓名"
                                label-width="104px"
                                prop="accountName"
                                :rules="[
                                    { required: true, message: '请输入姓名' }
                                ]"
                            >
                                <el-input
                                    v-model.trim="ruleForm.accountName"
                                    placeholder="请输入姓名"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    maxlength="20"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="身份证号"
                                label-width="104px"
                                prop="idCard"
                                :required="false"
                                :rules="[
                                    {
                                        required: false,
                                        message: '请输入身份证号',
                                        trigger: 'blur'
                                    },
                                    {
                                        required: false,
                                        message: '请输入身份证号',
                                        trigger: 'change'
                                    },
                                    {
                                        required: false,
                                        validator: checkId,
                                        trigger: 'blur'
                                    },
                                    {
                                        required: false,
                                        validator: checkId,
                                        trigger: 'change'
                                    }
                                ]"
                            >
                                <el-input
                                    v-model.trim="ruleForm.idCard"
                                    placeholder="请输入身份证号"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    maxlength="20"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="学历"
                                label-width="104px"
                                prop="hospitalName"
                            >
                                <el-select
                                    v-model="ruleForm.educationBackgroundCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="handleEducationChange"
                                    @clear="handleEducationChange"
                                    placeholder="请选择学历"
                                >
                                    <el-option
                                        v-for="(item, index) in educationList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                label="性别"
                                label-width="104px"
                                prop="accountSex"
                            >
                                <el-radio-group v-model="ruleForm.accountSex">
                                    <el-radio label="1">男</el-radio>
                                    <el-radio label="0">女</el-radio>
                                    <el-radio label="2">未知</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item
                                label="登录手机号"
                                label-width="104px"
                                prop="phone"
                                :rules="[
                                    {
                                        required: true,
                                        message: '请输入登录手机号'
                                    },
                                    {
                                        pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                                        required: true,
                                        message: '请输入正确的登录手机号'
                                    }
                                ]"
                            >
                                <el-input
                                    v-model.trim="ruleForm.phone"
                                    placeholder="请输入登录手机号"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    maxlength="20"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <div class="doctor-base-info">
                    <div class="info-title">执业信息</div>
                    <el-row>
                        <el-col :span="8" class="auto-select">
                            <el-form-item
                                label="医院"
                                label-width="72px"
                                prop="hospitalId"
                                :rules="[
                                    { required: true, message: '请输入医院' }
                                ]"
                            >
                                <el-select
                                    filterable
                                    clearable
                                    remote
                                    :disabled="haveDept"
                                    :remote-method="getHospital"
                                    :loading="isSearchDept"
                                    loading-text="正在搜索医院，请稍后..."
                                    v-model="ruleForm.hospitalId"
                                    placeholder="请输入关键字搜索"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="handleHosChange"
                                    @clear="handleHosChange"
                                >
                                    <el-option
                                        :label="item.hospitalName"
                                        :value="item.hospitalId"
                                        v-for="(item, index) in hospitalList"
                                        :key="index"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="角色"
                                label-width="72px"
                                prop="roleIds"
                            >
                                <el-select
                                    v-model="ruleForm.roleIds"
                                    multiple
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    placeholder="请选择角色"
                                >
                                    <el-option
                                        v-for="(item, index) in roleList"
                                        :key="index"
                                        :label="item.roleName"
                                        :value="item.roleId"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                label="科室"
                                label-width="104px"
                                prop="departmentId"
                                :rules="[
                                    { required: true, message: '请选择科室' }
                                ]"
                            >
                                <el-cascader
                                    class="form-cas-select"
                                    size="small"
                                    :style="{ width: '210px' }"
                                    v-model="ruleForm.departmentId"
                                    placeholder="请选择科室"
                                    :options="departList"
                                    :props="defaultProps"
                                    @focus="isHaveHospital"
                                    :visible-arrow="false"
                                    clearable
                                    filterable
                                ></el-cascader>
                            </el-form-item>
                            <el-form-item
                                label="职称"
                                label-width="104px"
                                prop="titleCode"
                                :rules="[
                                    { required: true, message: '请选择职称' }
                                ]"
                            >
                                <el-select
                                    v-model="ruleForm.titleCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="handleTitleChange"
                                    @clear="handleTitleChange"
                                    placeholder="请选择职称"
                                >
                                    <el-option
                                        v-for="(item, index) in doctorJobList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="auto-select">
                            <el-form-item
                                label="工号"
                                label-width="104px"
                                prop="accountNumber"
                            >
                             <!-- :rules="[
                                    { required: true, message: '请输入工号' }
                                ]"
                                v-if="searchHospitalId === '34'" -->
                                <el-input
                                    v-model.trim="ruleForm.accountNumber"
                                    placeholder="请输入工号"
                                    :style="{ width: '200px' }"
                                    size="small"
                                    maxlength="20"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item
                        class="form-details"
                        label="简介"
                        label-width="72px"
                        prop="doctorResume"
                    >
                        <el-input
                            v-model.trim="ruleForm.doctorResume"
                            type="textarea"
                            :style="{ width: '720px', height: '132px' }"
                            placeholder="请输入简介"
                            maxlength="700"
                            show-word-limit
                            class="introduction-detail"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        class="form-details"
                        label="擅长"
                        label-width="72px"
                        prop="doctorSpecial"
                    >
                        <el-input
                            v-model.trim="ruleForm.doctorSpecial"
                            type="textarea"
                            :style="{ width: '720px', height: '132px' }"
                            placeholder="请输入擅长"
                            maxlength="700"
                            show-word-limit
                            class="introduction-detail"
                        ></el-input>
                    </el-form-item>
                </div>
                <div class="doctor-base-info cert-info">
                    <div class="info-title">
                        认证信息<span class="heart-warning"
                            >(提示:建议图片小于10M,图片格式为png、jpg、jpeg)</span
                        >
                    </div>
                    <el-form-item
                        label="身份证正面"
                        label-width="115px"
                        class="item-last"
                        prop="idCardFront"
                        :rules="[
                            { required: true, message: '请上传身份证正面照' }
                        ]"
                        style="padding-bottom:6px"
                    >
                        <el-upload
                            class="papers-uploader"
                            :action="picUrl"
                            :headers="headers"
                            :on-success="handleCardFrontSuccess"
                            :on-remove="handleCardFrontRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="sfz_renxiang" />
                        </el-upload>
                        <div class="heart-warning">
                            请上传身份证正面照
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="add-btn-bottom">
            <el-button
                type="warning"
                size="small"
                @click="handleCreate()"
                :disabled="flag"
                >创 建</el-button
            >
            <el-button type="info" size="small" plain @click="cancleCreate()"
                >取 消</el-button
            >
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            :show-close="false"
            width="600px"
            class="ww-pre-dialog"
        >
            <img width="100%" :src="dialogImageUrl" alt="" />
            <span slot="title">
                <el-image
                    class="icon-delete"
                    :src="deleteUrl"
                    @click="handleImgClose"
                >
                </el-image>
            </span>
        </el-dialog>
        <!-- 裁剪图片弹框 -->
        <el-dialog
            :visible.sync="cropperVisible"
            :destroy-on-close="true"
            width="718px"
            title="头像编辑"
            class="ww-dialog"
        >
            <CropperPic
                ref="vueCropper"
                :imgFile="fileImg"
                @uploadFile="uploadFile"
            >
            </CropperPic>
        </el-dialog>
        <el-dialog
            :visible.sync="cropperPrewVisible"
            :show-close="false"
            top="30vh"
            width="400px"
            class="ww-pre-dialog"
        >
            <span slot="title">
                <el-image
                    class="icon-delete"
                    :src="deleteUrl"
                    @click="handleAvartClose"
                >
                </el-image>
            </span>
            <img width="100%" :src="imageUrl" alt="" />
        </el-dialog>
    </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
import { checkCard } from "@/utils/IDCard";
import CropperPic from "@/components/cropperPic";
import { checkFileSize } from "@/utils/checkFiles";
export default {
    name: "nurseAdd",
    data() {
        return {
            proFileUploadForm: {},
            defaultProps: {
                emitPath: false,
                label: "groupName",
                value: "groupId"
            },
            flag: false,
            picUrl: "",
            loading: false,
            breadList: [
                { label: "用户管理" },
                { label: "用户列表", path: "/user/userList" },
                { label: "新增护士" }
            ],
            ruleForm: {
                identities: "nurse", // 护士
                hospitalId: "", // 医院id
                hospitalName: "", // 医院名称
                accountHead: "", // 头像
                accountName: "", // 用户姓名
                accountNumber: "", // 用户账号(工号)
                accountSex: "", // 性别
                doctorResume: "", // 简介
                doctorSpecial: "", // 擅长
                educationBackgroundCode: "", // 学历code
                educationBackgroundName: "", // 学历code
                titleName: "", // 职称
                titleCode: "", // 职称code
                idCard: "", // 身份证号
                idCardFront: "", // 身份证图片正面
                phone: "", // 手机号
                departmentId: "", // 科室id
                roleIds: [] // 角色
            },
            haveDept: false, // 搜索
            isSearchDept: false,
            searchHospitalId: "", // 搜索医院ID 关联科室
            hospitalList: [], // 搜索的医院列表
            departList: [], // 科室列表
            gropList: [], // 集团列表
            roleList: [], // 角色列表
            dialogImageUrl: "", // 预览
            dialogVisible: false, // 预览显示
            // 剪切图片
            fileImg: {},
            cropperVisible: false,
            imageUrl: "",
            ceshiUrl:
                "/ms-hoc-video/v1/image/download?fileName=40cb9fcba2f04219961f96fc3c080303.png",
            cropperPrewVisible: false,
            deleteUrl: require("../../../assets/imgs/delete.png")
        };
    },
    components: {
        CropperPic
    },
    updated() {
        if (this.$refs.vueCropper) {
            this.$refs.vueCropper.updateOption();
        }
    },
    computed: {
        ...mapGetters(["dictionary", "userInfo"]),
        headers() {
            return { Authorization: "Bearer " + getToken() + "" || undefined };
        }
    },
    created() {
        this.getSelect();
        this.picUrl = `/ms-hoc-material/v3/file/uploadSingleFile?folder=hoc`;
        // this.picUrl = `/ms-hoc-video/v1/image/upload?hospitalId=${this.userInfo.hospitalId}&iuid=${this.userInfo.iuid}&ImageType=DOCTOR_INFO_IMAGE`
    },
    methods: {
        // 上传图片之前 限制
        beforeUploadProfile(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(
                file,
                this,
                2,
                "建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1284px*810px"
            );
        },
        // 处理下拉列表
        getSelect() {
            this.doctorJobList = this.dictionary.HSZC;
            this.educationList = this.dictionary.XL;
            // this.facultyList = this.dictionary.JZ
            this.getRole();
        },
        async getRole() {
            const { results } = await this.$services.hospital.getRoleList();
            this.roleList = results;
        },
        // 验证身份证
        checkId(rule, value, callback) {
            if (value) {
                if (checkCard(value) === false) {
                    callback(new Error("请输入正确的身份证号"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        // 身份证正面图片上传
        handleCardFrontSuccess(res, file) {
            let data = res.results;
            this.ruleForm.idCardFront = data[0].fileId;
            this.$refs["ruleForm"].validateField("idCardFront");
        },
        // 头像上传成功
        handleAvatarSuccess(res, file) {
            let data = res.results;
            this.ruleForm.accountHead = data[0].originPictureId;
        },
        // 身份证正面图片删除
        handleCardFrontRemove(file, fileList) {
            this.ruleForm.idCardFront = "";
        },
        // 医院搜索
        async getHospital(value) {
            this.isSearchDept = true;
            const params = {
                searchName: value
            };
            const {
                results
            } = await this.$services.hospital.getAllHospitalList(params);
            this.isSearchDept = false;
            this.hospitalList = results;
            this.departList = [];
        },
        isHaveHospital(value) {
            if (!this.searchHospitalId) {
                this.$message({
                    message: "请先输入医院",
                    customClass: "hos-message--warning",
                    iconClass: "el-icon-warning",
                    duration: "1000"
                });
            }
        },
        // 创建医生
        handleCreate() {
            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    this.handlePostDoctor();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 取消创建
        cancleCreate() {
            this.$router.push("/user/userList");
        },
        // 获取 树状 科室
        async getTreeDepart(data) {
            let params = {
                hospitalId: data
            };
            const { results } = await this.$services.hospital.getTreeDeptList(
                params
            );
            this.departList = results;
        },
        // ------------code name----------
        // 添加医院name
        handleHosChange(val) {
            this.searchHospitalId = val;
            this.departList = [];
            this.ruleForm.departmentId = "";
            let obj = {};
            obj = this.hospitalList.find(item => {
                return item.hospitalId === val;
            });
            if (val) {
                this.ruleForm.hospitalName = obj.hospitalName;
                this.getTreeDepart(val);
            } else {
                this.ruleForm.hospitalName = "";
            }
        },
        // 学历name
        handleEducationChange(val) {
            let obj = {};
            obj = this.educationList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.educationBackgroundName = obj.dictDataValue;
            } else {
                this.ruleForm.educationBackgroundName = "";
            }
        },
        // 职称name
        handleTitleChange(val) {
            let obj = {};
            obj = this.doctorJobList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.titleName = obj.dictDataValue;
            } else {
                this.ruleForm.titleName = "";
            }
        },
        // ------------code name------------------
        // 请求接口创建医生
        async handlePostDoctor() {
            this.loading = true;
            this.flag = true;
            let param = this.ruleForm;
            const {
                results,
                state,
                subMsg
            } = await this.$services.hospital.addDoctor(param);
            this.loading = false;
            this.flag = false;
            if (state !== 200) {
                this.$message({
                    message: subMsg,
                    type: "warning"
                });
            }
            if (state === 200 && results) {
                this.$message({
                    message: "创建护士成功",
                    customClass: "hos-message--success",
                    iconClass: "el-icon-success",
                    duration: "1000"
                });
                this.$router.push("/user/userList");
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 剪切提交图片-------
        changeUpload(file, fileList) {
            if (file && file.size / 1024 / 1024 > 1) {
                return this.$message.warning(
                    "建议图片小于1M，图片格式为png、jpg、jpeg，图片尺寸建议500px*500px"
                );
            }
            this.fileImg = file;
            this.cropperVisible = true;
        },
        // 提交图片
        async uploadFile(data) {
            let hospitalId = this.userInfo.hospitalId;
            let iuid = this.userInfo.iuid;
            let formData = new FormData();
            formData.append("file", data);
            const { results, state } = await this.$services.hospital.imgUpload(
                formData,
                hospitalId,
                iuid
            );

            if (state === 200 && results) {
                this.cropperVisible = false;
                this.imageUrl =
                    "/ms-hoc-video/v1/image/download?fileName=" +
                    results[0].originPictureId;
                this.ruleForm.accountHead = results[0].originPictureId;
            } else {
                this.$refs.vueCropper.cropperLoadding = false;
                this.$message({
                    message: "上传头像失败，请稍后再试",
                    customClass: "hos-message--error",
                    iconClass: "el-icon-error",
                    duration: "1000"
                });
            }
        },
        avartIn() {
            this.cropperPrewVisible = true;
        },
        avartDele() {
            this.imageUrl = "";
            this.ruleForm.accountHead = "";
        },
        handleImgClose() {
            this.dialogVisible = false;
        },
        handleAvartClose() {
            this.cropperPrewVisible = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.user-add-wrap-out {
    .doctorAdd-wrap {
        background: #ffffff;
        margin: 20px;
        padding: 20px 20px 0px 20px;
        overflow: hidden;
        box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
        .doctor-title {
            padding-bottom: 8px;
            font-size: 14px;
            color: #333333;
            border-bottom: 1px solid #cccccc;
            i {
                color: $color-primary;
            }
            span {
                margin-left: 8px;
            }
        }
        .doctor-base-info {
            border-bottom: 1px solid #cccccc;
            padding-top: 20px;
            .avart-wrap {
                position: relative;
                .avatar-uploader {
                    .avatar-show {
                        width: 118px;
                    }
                    .avatar-img {
                        width: 120px;
                        height: 120px;
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        position: relative;
                        i {
                            width: 24px;
                            height: 21px;
                            font-size: 20px;
                            color: #ffffff;
                            position: absolute;
                            top: -26px;
                        }
                        div {
                            color: #ffffff;
                            font-size: 14px;
                        }
                        .uploader-title {
                            width: 56px;
                            height: 14px;
                            color: #ffffff;
                            font-size: 14px;
                        }
                    }
                }
                .cover-custom {
                    width: 120px;
                    height: 120px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 888;
                    .cover-wrap {
                        width: 120px;
                        height: 120px;
                        background: rgba(0, 0, 0, 0.4);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        opacity: 0;
                        i {
                            color: #ffffff;
                            font-size: 20px;
                            cursor: pointer;
                        }
                        i:first-child {
                            margin-right: 10px;
                        }
                    }
                }
                .cover-custom:hover .cover-wrap {
                    animation: myfirst 0.5s;
                    -moz-animation: myfirst 0.5s; /* Firefox */
                    -webkit-animation: myfirst 0.5s; /* Safari 和 Chrome */
                    -o-animation: myfirst 1s; /* Opera */
                    animation-fill-mode: forwards; /*ie9 及以下不支持 */
                    -moz-animation-fill-mode: forwards;
                    -webkit-animation-fill-mode: forwards;
                    -o-animation-fill-mode: forwards;
                }
                // ceshi
                @keyframes myfirst {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                @-moz-keyframes myfirst {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                @-webkit-keyframes myfirst {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                @-o-keyframes myfirst {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }
            }
            .form-tips-text {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                line-height: 14px;
                margin: 20px 0;
            }
        }
        .doctor-base-info:last-child {
            border-bottom: none;
        }
        .info-title {
            margin-bottom: 20px;
            border-left: 4px solid $color-primary;
            padding-left: 8px;
            height: 16px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            line-height: 16px;
            color: #333333;
            text-align: left;
            .heart-warning {
                margin-left: 8px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #666666;
                text-align: left;
                line-height: 12px;
            }
        }
        .cert-info {
            .papers-uploader {
                .icon {
                    font-size: 140px;
                }
            }
            .heart-warning {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #999999;
                letter-spacing: 0;
                line-height: 16px;
            }
            .ele-sign {
                .sign-qian {
                    width: 70px;
                    height: 70px;
                    position: relative;
                    .icon {
                        position: absolute;
                        left: 0;
                        top: 0;
                    }
                }
            }
        }
        // 标签信息开始
        .set-label {
            border-bottom: none;
            .label-wrap {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                line-height: 14px;
                padding-left: 14px;
                .label-team {
                    margin-bottom: 20px;
                    display: flex;
                    .label-team-left {
                        margin-right: 20px;
                        min-width: 56px;
                        line-height: 18px;
                    }
                    .label-team-right {
                        .label-team-select {
                            // margin-bottom: 10px;
                            color: $color-primary;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            i {
                                font-size: 18px;
                                margin-right: 8px;
                            }
                        }
                        .label-team-content {
                            display: flex;
                            flex-wrap: wrap;
                            .team-content-item {
                                margin-top: 10px;
                                margin-right: 10px;
                                display: flex;
                                align-items: center;
                                height: 24px;
                                padding: 0 10px;
                                border: 1px solid #f2f2f2;
                                border-radius: 3px;
                                color: #333333;
                                .wow-user {
                                    margin-right: 10px;
                                    font-size: 10px;
                                    color: $color-primary;
                                }
                                .wow-close {
                                    margin-left: 10px;
                                    font-size: 6px;
                                    color: #999999;
                                    cursor: pointer;
                                }
                                .wow-folder {
                                    margin-right: 10px;
                                    width: 11px;
                                    height: 11px;
                                    display: inline-block;
                                    background: url("../../../assets/imgs/folder.png")
                                        no-repeat;
                                    background-size: cover;
                                }
                            }
                        }
                    }
                }
            }
        }
        // 标签信息结束
    }
    .add-btn-bottom {
        width: 100%;
        height: 60px;
        background: #f9f9f9;
        border-top: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    // 团队
    .dialog-tema-content {
        padding-right: 10px;
        height: 400px;
        overflow: auto;
        .dialog-tema-item {
            margin-bottom: 14px;
            display: flex;
            justify-content: space-between;
            .dialog-tema-item-left {
                span {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    letter-spacing: 0;
                    line-height: 12px;
                }
            }
            .wow-user {
                margin-right: 10px;
                font-size: 10px;
                color: $color-primary;
            }
        }
    }
    // 无数据
    .dialog-none-data {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .icon {
            font-size: 80px;
        }
        span {
            line-height: 14px;
            font-size: 12px;
        }
    }
}
</style>
<style lang="scss">
.doctor-base-info {
    .el-textarea__inner {
        padding: 5px 15px 32px 15px !important;
    }
}
// 标签弹窗布局
.el-dialog__wrapper {
    .member-wow-dialog {
        .el-dialog__body {
            padding: 0;
            .member-content {
                height: 453px;
                display: flex;
                .left-wraper {
                    padding-left: 10px;
                    width: 340px;
                    border-right: 1px solid #dcdcdc;
                    .search-content {
                        margin: 10px 0;
                        width: 319px;
                        padding-right: 10px;
                        .search-tema {
                            width: 319px;
                            vertical-align: middle;
                            .el-input__inner {
                                border-radius: 3px;
                                border-color: #dcdcdc;
                                padding: 8px 32px 8px 10px;
                                height: 32px;
                            }

                            .el-input__suffix {
                                background: $color-primary;
                                color: #fff;
                                right: 0;
                                cursor: pointer;
                                border-radius: 0 3px 3px 0;

                                i {
                                    display: inline-block;
                                    width: 36px;
                                    font-size: 14px;
                                    line-height: 32px;
                                    border-radius: 3px;
                                }
                            }
                        }
                    }
                    .table-content {
                        margin-top: 10px;
                    }
                }
                .right-wraper {
                    width: 220px;
                    padding: 20px;
                    padding-right: 0px;
                    overflow: hidden;
                    .content_text {
                        padding-right: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .choose_text {
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #999999;
                            letter-spacing: 0;
                        }
                        .empty_text {
                            cursor: pointer;
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #198eeb;
                            letter-spacing: 0;
                        }
                    }
                    .choose-member {
                        height: 396px;
                        padding-right: 20px;
                        overflow: auto;
                        margin-top: 10px;
                        padding-top: 10px;
                        .item-member {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 10px;
                            .icon-user1 {
                                font-size: 14px;
                                color: #06aea6;
                            }
                            .el-icon-close {
                                color: #999;
                                font-size: 14px;
                                cursor: pointer;
                            }
                            .member-text {
                                margin-left: 10px;
                                font-family: PingFangSC-Regular;
                                font-size: 12px;
                                color: #333333;
                                letter-spacing: 0;
                            }
                        }
                    }
                }
            }
        }
        .el-dialog__footer {
            background: #f9f9f9;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            .dialog-footer {
                .dialog-confirm-btn {
                    width: 100px;
                    height: 32px;
                    padding: 0;
                }
                .dialog-cancle {
                    width: 100px;
                    height: 32px;
                    padding: 0;
                    margin-left: 16px;
                }
            }
        }
    }
}
.dialog-tema-content {
    // checkbox
    .el-checkbox-group {
        .el-checkbox {
            display: flex;
            justify-content: space-between;
            flex-flow: row-reverse;
            margin-bottom: 14px;
            margin-right: 0px;
            .el-checkbox__label {
                padding-left: 0px;
                font-size: 12px;
                float: left;
                color: #333333;
                i {
                    margin-right: 10px;
                    font-size: 12px;
                    color: $color-primary;
                }
                .depart-icon {
                    margin-right: 10px;
                }
            }
        }
    }
}
.depart-icon {
    display: inline-block;
    width: 14px;
    height: 12px;
}
</style>
